import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Nudjene_cijene } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-nudjene-cijene',
  templateUrl: './nudjene-cijene.component.html',
  styleUrls: ['./nudjene-cijene.component.scss']
})
export class NudjeneCijeneComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService, 
    private cdRef: ChangeDetectorRef, 
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
  }

  startDate: Date = new Date(new Date().toDateString());
  endDate: Date = new Date(new Date(new Date().toDateString()).setHours(23, 59, 59, 999));
  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#nudjeneCijeneGrid' };
  createNudjeneCijenePopupVisible: boolean = false;
  editNudjeneCijenePopupVisible: boolean = false;
  isUserModerator: boolean = false;
  selectedNudjeneCijene: Nudjene_cijene;

  @ViewChild('nudjeneCijeneGrid', { static: false }) nudjeneCijeneGrid: DxDataGridComponent;

  ngOnInit() {
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
  }

  onStartDateChange(event: any) {
    this.startDate = event;
  }

  onEndDateChange(event: any) {
    this.endDate = event;
  }

  isFormValid(): boolean {
    return !!this.startDate && !!this.endDate;
  }

  toLocalAsUTC(date: Date): Date {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate;
  }

  async loadData() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    
    try {
      const result = await this.apiClient.nudjeneCijeneAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
      this.gridData = result;

    } catch (error) {
      console.error('Error loading nudjene cijene data:', error);
    } finally {
      this.loading = false;
    }
  }

  showCreateNudjeneCijene() {
    this.createNudjeneCijenePopupVisible = true;
  }

  async onNudjeneCijeneCreated(e: Nudjene_cijene) {
    await this.loadData();
  }

  async onNudjeneCijeneEdited(e: Nudjene_cijene) {
    await this.loadData();
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const nudjeneCijene = e.row.data;

    try {
      await this.apiClient.nudjeneCijeneDELETE(nudjeneCijene.id);

      const index = this.gridData.findIndex(item => item.id === nudjeneCijene.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting nudjene cijene:', error);
    }
  }

  onEditClick(e: any) {
    this.selectedNudjeneCijene = e.row.data;
    this.cdRef.detectChanges();
    this.editNudjeneCijenePopupVisible = true;
  }
}